module.exports = __webpack_public_path__ + "static/img/SUB_02_03.5681814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/SUB_02_03.png
// module id = P77R
// module chunks = 1